import type { RootScope } from '../../types';

import angular from 'angular';
import $ from 'jquery';

import { logger } from '../../services/logger';

export interface RequestService {
  post<T = { [key: string]: any }>(
    url: string,
    data: { [key: string]: any },
    callback: (resp: angular.IHttpResponse<T>) => void,
    errCallback: (resp: angular.IHttpResponse<any>) => void,
  ): void;
  get<T = { [key: string]: any }>(
    url: string,
    data: { [key: string]: any },
    callback: (resp: angular.IHttpResponse<T>) => void,
  ): void;
}

export default angular
  .module('estoffice.legacy.request', [])
  .factory('request', [
    '$http',
    '$rootScope',
    function (
      $http: angular.IHttpService,
      $rootScope: RootScope,
    ): RequestService {
      return {
        post: (url, data, callback, errCallback) => {
          if (!data.token) {
            data.token = $rootScope.token;
          }

          $rootScope.requestLoader = true;

          if (url) {
            $http<any>({
              method: 'POST',
              url,
              data: $.param(data),
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
            })
              .then(function (response) {
                $rootScope.requestLoader = false;

                if (typeof callback === 'function') {
                  callback(response);
                }
              })
              .catch(function (error) {
                if (typeof errCallback === 'function') {
                  errCallback(error);
                }

                logger.error('Error performing request', { error });
              });
          }
        },
        get: (url, data, callback) => {
          if (url) {
            $http<any>({
              method: 'GET',
              url: `${url}?${$.param(data)}`,
            })
              .then(function (response) {
                if (typeof callback === 'function') {
                  callback(response);
                }
              })
              .catch(function (error) {
                logger.error('Error performing request', { error });
                $rootScope.showLoader = false;
              });
          }
        },
      };
    },
  ]);
